import React from 'react';
import PropTypes from 'prop-types';
import rtl from 'jss-rtl';
import { create } from 'jss';
import cookie from 'react-cookies';
import { JssProvider } from 'react-jss';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { MuiThemeProvider, createMuiTheme, createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import Routes from './routes';
import AuthRoutes from './authRoutes';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const generateClassName = createGenerateClassName();

let token = null;
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentWillMount = async () => {
    await this.authenticate();
  }

  componentWillReceiveProps = async (nextProps) => {
    if (document.body) {
      document.body.dir = nextProps.themeConfig.contentTheme.direction;
    }
    await this.authenticate();
  }

  getToken = async () => {
    const authToken = await cookie.load('token');
    return authToken;
  }

  authenticate = async () => {
    token = await this.getToken();
    this.setState(this.state);
  }

  render() {
    const childProps = {};
    const { themeConfig, layoutConfig } = this.props;

    sessionStorage.setItem(
      'portalData',
      JSON.stringify({
        theme: {
          ...themeConfig
        },
        layout: {
          ...layoutConfig
        }
      })
    );

    const materialTheme = createMuiTheme(themeConfig.contentTheme);

    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <MuiThemeProvider theme={materialTheme}>
          {
            (token) ? (
              <Routes childProps={childProps} layout={layoutConfig} />
            ) : (
                <AuthRoutes childProps={childProps} layout={layoutConfig} />
              )
          }
        </MuiThemeProvider>
      </JssProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    themeConfig: state.theme,
    layoutConfig: state.layout
  };
}

App.propTypes = {
  themeConfig: PropTypes.shape({
    contentTheme: PropTypes.shape({
      direction: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  layoutConfig: PropTypes.shape({}).isRequired
};

export default compose(
  withRouter,
  connect(mapStateToProps)
)(App);



// WEBPACK FOOTER //
// ./src/app.component.js